<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('locations.create_location') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.location') }} <strong>{{ location.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
            <app-location-new *ngIf="newMode()"></app-location-new>
            <app-location-basedata *ngIf="editMode()" [location]="location"></app-location-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
